/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExistingWorkEntries } from '../../models/existing-work-entries';

export interface ApiV0ConstructiondayreportExistingWorkEntriesCompanyDateGet$Plain$Params {
  company: string;
  date: string;
}

export function apiV0ConstructiondayreportExistingWorkEntriesCompanyDateGet$Plain(http: HttpClient, rootUrl: string, params: ApiV0ConstructiondayreportExistingWorkEntriesCompanyDateGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ExistingWorkEntries>> {
  const rb = new RequestBuilder(rootUrl, apiV0ConstructiondayreportExistingWorkEntriesCompanyDateGet$Plain.PATH, 'get');
  if (params) {
    rb.path('company', params.company, {});
    rb.path('date', params.date, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExistingWorkEntries>;
    })
  );
}

apiV0ConstructiondayreportExistingWorkEntriesCompanyDateGet$Plain.PATH = '/api/v0/constructiondayreport/existing-work-entries/{company}/{date}';
